import { Presenter } from '@d-id/types';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import PersonIcon from '@mui/icons-material/Person';
import { IconButton, Typography } from '@mui/material';
import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import { AvatarCard, AvatarImage, AvatarInfo, DragHandle } from '../../shared/AvatarsOrdering';

interface AvatarItemProps {
    avatar: Presenter;
    index: number;
    provided: DraggableProvided;
    snapshot: DraggableStateSnapshot;
    onCreateGroup: (avatar: Presenter) => void;
}

export const AvatarItem = ({ avatar, index, provided, snapshot, onCreateGroup }: AvatarItemProps) => {
    return (
        <AvatarCard ref={provided.innerRef} {...provided.draggableProps} isDragging={snapshot.isDragging}>
            <DragHandle {...provided.dragHandleProps}>
                <DragIndicatorIcon />
            </DragHandle>
            <PersonIcon sx={{ mr: 1, color: 'primary.main' }} />
            <AvatarImage src={avatar.thumbnail || avatar.poster} alt={avatar.name} />
            <AvatarInfo>
                <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '1rem' }}>
                    #{index + 1} - {avatar.name}
                </Typography>
            </AvatarInfo>
            <IconButton size="small" onClick={() => onCreateGroup(avatar)} title="Create group">
                <GroupWorkIcon />
            </IconButton>
        </AvatarCard>
    );
};
